import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import * as React from 'react';
import { QueryRoute, RouteStore, AnalyticsStore } from 'bernie-core';
import { Layer } from 'bernie-view';
import { ActivityDetailOffers } from '../../common/__generated__/api';

interface PopupMessageProps {
  dialogId: string;
  isNestedPopup?: boolean;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  clickAction?: ActivityDetailOffers.ClickAction | null;
  linkRef: React.RefObject<any>;
}

export const PopupMessage = (props: PopupMessageProps): JSX.Element | null => {
  const { dialogId, isNestedPopup, routeStore, clickAction, analytics, linkRef } = props;

  if (!routeStore || !clickAction) {
    return null;
  }

  const onDismiss = (): void => {
    if (clickAction.dismissAction && clickAction.dismissAction.rfrr && analytics) {
      analytics.trackEvent(clickAction.dismissAction.rfrr, 'more-info-popup-close', analytics.omnitureData, null, true);
    }
    routeStore.goBack();
    linkRef.current.focus();
  };

  return (
    <QueryRoute query={isNestedPopup ? { pwaDialogNested: dialogId } : { pwaDialog: dialogId }}>
      <Layer id={`${dialogId}-layer`}>
        <UitkDialog dialogShow={true}>
          {clickAction.text && (
            <UitkDialogContent key={`${dialogId}-dialog`}>
              <div className="uitk-type-300">{clickAction.text}</div>
            </UitkDialogContent>
          )}
          {clickAction.dismissAction && clickAction.dismissAction.text && (
            <UitkDialogFooter
              key={`${dialogId}-footer`}
              buttonOne={{
                onClick: (): void => onDismiss(),
                text: clickAction.dismissAction.text,
                type: 'tertiary'
              }}
            />
          )}
        </UitkDialog>
      </Layer>
    </QueryRoute>
  );
};
